import img1 from '../assets/estruturacao/1.png'
import img2 from '../assets/estruturacao/2.png'
import img3 from '../assets/estruturacao/3.png'
import img4 from '../assets/estruturacao/4.png'

/** Oculta promo no dashboard e item no submenu; rotas e páginas permanecem ativas. */
export const SHOW_ESTRUTURACAO_UI = false

export const ESTRUTURACAO_SECTIONS = [
  {
    screenId: 'estruturacao-comercial',
    route: '/estruturacao/comercial',
    image: img1,
    labelKey: 'estruturacao.sections.comercial',
    subtitleKey: 'estruturacao.sections.comercialSubtitle',
    badge: '01',
    accentFrom: '#2563eb',
    accentTo: '#1d4ed8',
    iconPath: 'M13 7h8m0 0v8m0-8l-8 8-4-4-6 6'
  },
  {
    screenId: 'estruturacao-atendimentos',
    route: '/estruturacao/atendimentos',
    image: img2,
    labelKey: 'estruturacao.sections.atendimentos',
    subtitleKey: 'estruturacao.sections.atendimentosSubtitle',
    badge: '02',
    accentFrom: '#0891b2',
    accentTo: '#0e7490',
    iconPath: 'M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z'
  },
  {
    screenId: 'estruturacao-operacional',
    route: '/estruturacao/operacional',
    image: img3,
    labelKey: 'estruturacao.sections.operacional',
    subtitleKey: 'estruturacao.sections.operacionalSubtitle',
    badge: '03',
    accentFrom: '#7c3aed',
    accentTo: '#6d28d9',
    iconPath: 'M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z'
  },
  {
    screenId: 'estruturacao-financeira',
    route: '/estruturacao/financeira',
    image: img4,
    labelKey: 'estruturacao.sections.financeira',
    subtitleKey: 'estruturacao.sections.financeiraSubtitle',
    badge: '04',
    accentFrom: '#059669',
    accentTo: '#047857',
    iconPath: 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
  }
]

export const ESTRUTURACAO_SCREEN_IDS = ESTRUTURACAO_SECTIONS.map((section) => section.screenId)

export function isEstruturacaoScreenId(screenId) {
  return ESTRUTURACAO_SCREEN_IDS.includes(screenId)
}
